module.exports = __webpack_public_path__ + "static/sec1-6a3c1774a5f545fd44a80e1c1ecce823.png";